export default "/images/b6780ff06afe33a6564192bc2fc530db.avif";